import { useEffect, useState } from "react";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { ToastProvider } from "./components/Toast";
import { LoginPage } from "./pages/LoginPage";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { Dashboard } from "./pages/Dashboard";

/** 根据当前路径决定渲染登录态还是主界面（轻量“路由”） */
function useIsCallbackRoute(): boolean {
  const [isCallback, setIsCallback] = useState(
    () => window.location.pathname === "/auth/callback",
  );
  useEffect(() => {
    const onPop = () => setIsCallback(window.location.pathname === "/auth/callback");
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return isCallback;
}

function Root() {
  const { user, initializing } = useAuth();
  const isCallback = useIsCallbackRoute();

  if (initializing) {
    return (
      <div className="login-page">
        <div className="login-card centered">
          <h1>📅 会议效能监测平台</h1>
          <div className="sub mt-12">
            <span className="spinner" />
            正在恢复登录态…
          </div>
        </div>
      </div>
    );
  }

  // 已登录但停在回调页：直接进主界面（登录态已由回调写入）
  if (user) return <Dashboard />;
  if (isCallback) return <AuthCallbackPage />;
  return <LoginPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Root />
      </ToastProvider>
    </AuthProvider>
  );
}
